import request from '@/plugins/axios'

/** S 商城列表 **/
// 供应商列表
export const apiSupplierLists = (params: any) => request.get('/apiSuppliers/list', { params })

// 添加供应商
export const apiSupplierAdd = (params: any) => request.post('/apiSuppliers/add', params)

// 商品
export const apiSupplierShopList = (params: any) => request.get('/scrm.scrmGoods/lists', { params })

// 上下架商品
export const apiGoodsStatus = (data: any) => request.post('/scrm.scrmGoods/examine', data)
// 订单列表
export const apiSupplierOrderList = (params: any) => request.get('/scrm.order/lists', { params })
//导出
export const apiSupplierExport = (params: any) => request.get('/scrm.scrmGoods/export', { params })
//kp商品分类
export const apiKpGoodsClassify = (params: any) => request.get('/scrm.scrmGoods/categories', { params })
//供应商分类
export const apiGetCategory = (params: any) => request.get('/apiSuppliers/getCategory', { params })

//修改供应商分类
export const apiEditCategory = (params: any) => request.post('/apiSuppliers/editCategory', params)

//供应商绑定商户
export const apiGetBindShop = (params: any) => request.get('/apiSuppliers/getBindShop', { params })
//修改供应商绑定商户
export const apiEditBindShop = (params: any) => request.post('/apiSuppliers/bindShop', params)

//商品池
export const apiGoodsPool = (params: any) => request.get('/scrm.scrmGoodsPool/lists', { params })

//商品池商品详情

//商品池商品审核
export const apiGoodsPoolStatus = (data: any) => request.post('/scrm.scrmGoodsPool/examine', data)

//商品池导出
export const apiGoodsPoolExport = (params: any) => request.get('/scrm.scrmGoodsPool/export', { params })

//重置供应商密码
export const apiEditPassword = (data: any) => request.post('/apiSuppliers/resetPassword', data)
